import { Box, Checkbox, Typography } from '@percent/lemonade'

import type { OpportunityFormTimeTrackingCheckboxProps } from './opportunity-form-time-tracking-checkbox.types'
import styles from './opportunity-form-time-tracking-checkbox.module.scss'

export function OpportunityFormTimeTrackingCheckbox({
  value,
  onChange,

  label,
  description,
}: OpportunityFormTimeTrackingCheckboxProps) {
  return (
    <Box style={{ marginTop: '1.5rem' }}>
      <Checkbox
        name="manualTimeTracking"
        value={value ? 'true' : undefined}
        active={value}
        onChange={(e) => onChange(e.currentTarget.checked)}
        label={
          <Box>
            <Typography className={styles.TimeTrackingLabel}>
              {label}
            </Typography>
            <Typography className={styles.TimeTrackingDescription}>
              {description}
            </Typography>
          </Box>
        }
        variant="default"
      />
    </Box>
  )
}
